import { render } from "./Main.vue?vue&type=template&id=facb15da"
const script = {}
script.render = render

export default script